/**
 *
 * PortalSelect
 *
 * @version 0.0.5
 * @author Giuseppe
 * @since 13-Oct-2022
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, InputLabel, MenuItem, Select, Checkbox, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { generateUniqueId } from 'Utility/generateUniqueID';
import style from './PortalSelect.scss';

const PortalSelect = (props) => {
	const intl = useIntl();

	const handleRenderValue = () => {
		props.renderValue ? (selected) => selected.join(' - ') : false;
	};

	return (
		<Grid
			className={`
				${style.container}
        ${props.darkbackground ? style.darkbackground : ''}
        ${props.disabled ? style.disabled : ''}
        ${props.value !== undefined && props.value !== '' ? style.labelUp : ''}
    	`}>
			{props.label ? (
				<InputLabel id={`select-${props.id}-label`}>{`${intl.formatMessage(props.label)}${
					props.isRequired ? '*' : ''
				}`}</InputLabel>
			) : null}
			<Select
				name={props.id}
				variant='standard'
				labelId={`select-${props.id}-label`}
				id={props.id}
				value={props.value}
				onChange={props.onChange}
				onBlur={props.onBlur}
				multiple={props.multiple}
				disabled={props.disabled}
				renderValue={handleRenderValue()}>
				{props.menuItems && props.menuItems.length > 0
					? props.menuItems.map((menuItem, index) => (
							<MenuItem
								key={index}
								value={menuItem && menuItem.value}
								className={`${style.listItem} ${
									props.multiple && props.disabledList && !props.value.includes(menuItem && menuItem.value)
										? style.disabledList
										: ''
								}`}>
								{props.multiple ? (
									<>
										<Checkbox checked={props.value.indexOf(menuItem && menuItem.value) > -1} />
									</>
								) : null}
								<Typography variant='body1' className={style.value}>
									{props.translateMenuItemContent
										? menuItem && menuItem.content
											? intl.formatMessage(menuItem && menuItem.content)
											: menuItem && menuItem.value
											? intl.formatMessage(menuItem && menuItem.value)
											: ''
										: (menuItem && menuItem.content) || (menuItem && menuItem.value)}
								</Typography>
							</MenuItem>
					  ))
					: []}
			</Select>
		</Grid>
	);
};
PortalSelect.propTypes = {
	id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	label: PropTypes.object,
	value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]),
	defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	onChange: PropTypes.func.isRequired,
	onBlur: PropTypes.func,
	menuItems: PropTypes.arrayOf(
		PropTypes.exact({
			content: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number]),
			value: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number]),
		})
	).isRequired,
	translateMenuItemContent: PropTypes.bool,
	multiple: PropTypes.bool,
	renderValue: PropTypes.func,
	disabledList: PropTypes.bool,
	disabled: PropTypes.bool,
	darkbackground: PropTypes.bool,
	isRequired: PropTypes.bool,
};

PortalSelect.defaultProps = {
	id: generateUniqueId(),
	translateMenuItemContent: true,
	multiple: false,
	renderValue: () => {},
	disabledList: false,
	disabled: false,
	darkbackground: false,
	isRequired: false,
};

export default React.memo(PortalSelect);
